// src/components/Footer.js
import React from 'react';
import './Footer.css';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope, 
  faMapMarkerAlt, 
  faClock,
  faAngleRight,
  faHome,
  faTools,
  faShieldAlt,
  faHardHat,
  faBuilding,
  faChevronUp,
  faCheck
} from '@fortawesome/free-solid-svg-icons';


function Footer() {
  const currentYear = new Date().getFullYear();
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-info">
              <div className="footer-logo">
                <img 
                  src="/gallery/logo.PNG" 
                  alt="Old Glossop Roofing" 
                  className="footer-logo-img"
                />
                <div className="footer-logo-text">
                  <h2>Old Glossop Roofing</h2>
                  <p>Quality Roofing Services</p>
                </div>
              </div>
              <p className="footer-description">
                We provide professional roofing services to homes and businesses throughout Glossop and the surrounding areas. 
                Our team of experienced roofers delivers quality workmanship with exceptional customer service.
              </p>
            </div>
            
            <div className="footer-links">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-menu">
                <li>
                  <a href="/">
                    <FontAwesomeIcon icon={faAngleRight} className="footer-icon" />
                    Home
                  </a>
                </li>
                <li>
                  <a href="/services">
                    <FontAwesomeIcon icon={faAngleRight} className="footer-icon" />
                    Services
                  </a>
                </li>
                <li>
                    <a href="/gallery">
                      <FontAwesomeIcon icon={faAngleRight} className="footer-icon" />
                      Gallery
                    </a>
                </li>
                <li>
                  <a href="/areas-covered">
                    <FontAwesomeIcon icon={faAngleRight} className="footer-icon" />
                    Areas Covered
                  </a>
                </li>
                <li>
                  <a href="/contact">
                    <FontAwesomeIcon icon={faAngleRight} className="footer-icon" />
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="/login">
                    <FontAwesomeIcon icon={faAngleRight} className="footer-icon" />
                    Admin
                  </a>
                </li>
              </ul>
            </div>
            
            <div className="footer-services">
              <h3 className="footer-title">Our Services</h3>
              <ul className="footer-menu">
                <li>
                  <a href="/services#new-roofs">
                    <FontAwesomeIcon icon={faHome} className="footer-icon" />
                    New Roof Installation
                  </a>
                </li>
                <li>
                  <a href="/services#repairs">
                    <FontAwesomeIcon icon={faTools} className="footer-icon" />
                    Roof Repairs
                  </a>
                </li>
                <li>
                  <a href="/services#maintenance">
                    <FontAwesomeIcon icon={faShieldAlt} className="footer-icon" />
                    Roof Maintenance
                  </a>
                </li>
                <li>
                  <a href="/services#flat-roofing">
                    <FontAwesomeIcon icon={faBuilding} className="footer-icon" />
                    Flat Roofing
                  </a>
                </li>
                <li>
                  <a href="/services#guttering">
                    <FontAwesomeIcon icon={faHardHat} className="footer-icon" />
                    Guttering & Fascias
                  </a>
                </li>
              </ul>
            </div>
            
            <div className="footer-contact">
              <h3 className="footer-title">Contact Info</h3>
              <div className="contact-item">
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <div className="contact-info">
                  <h4>Call Us</h4>
                  <p>
                    <a href="tel:07735005695">07735 005 695</a>
                  </p>
                  <p>
                    <a href="tel:07393861306">07393 861 306</a>
                  </p>
                </div>
              </div>
              
              <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <div className="contact-info">
                  <h4>Email</h4>
                  <p>
                    <a href="mailto:info@oldglossooproofing.co.uk">oldglossoproofing@gmail.com</a>
                  </p>
                </div>
              </div>
              
              <div className="contact-item">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="contact-icon" />
                <div className="contact-info">
                  <h4>Location</h4>
                  <p>Glossop, Derbyshire</p>
                  <p>Serving Glossop & surrounding areas</p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-middle">
        <div className="container">
          <div className="credentials">
            <div className="credential">
              <div className="credential-icon">
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <span>Fully Insured</span>
            </div>
            <div className="credential">
              <div className="credential-icon">
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <span>Qualified Tradesmen</span>
            </div>
            <div className="credential">
              <div className="credential-icon">
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <span>Free Quotations</span>
            </div>
            <div className="credential">
              <div className="credential-icon">
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <span>Satisfaction Guaranteed</span>
            </div>
            <div className="credential">
              <div className="credential-icon">
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <span>Competitive Rates</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <p>&copy; {currentYear} Old Glossop Roofing. All Rights Reserved.</p>
          </div>
          <div className="footer-links-bottom">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
            <a href="/sitemap">Sitemap</a>
          </div>
          <button className="scroll-top" onClick={scrollToTop} aria-label="Scroll to top">
            <FontAwesomeIcon icon={faChevronUp} />
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;